(function () {
  const intro = document.getElementById('IntroVideoOverlay');
  if (!intro) return;

  const menuBtn = document.getElementById('IntroMenuBtn');
  const menuPanel = document.getElementById('IntroMenuPanel');

  const STORAGE_KEY = 'introSeen';

  function lockScroll(lock) {
    document.documentElement.classList.toggle('intro-lock', lock);
    document.body.classList.toggle('intro-lock', lock);
  }

  function openMenu(open) {
    if (!menuPanel) return;
    menuPanel.classList.toggle('is-open', open);
  }

  function showIntro() {
    intro.style.display = '';
    intro.setAttribute('aria-hidden', 'false');
    lockScroll(true);
    openMenu(false);

    const v = intro.querySelector('video');
    if (v) {
      v.muted = true;
      v.playsInline = true;
      const p = v.play();
      if (p && p.catch) p.catch(() => {});
    }
  }

  function hideIntro() {
    intro.style.display = 'none';
    intro.setAttribute('aria-hidden', 'true');
    lockScroll(false);
    openMenu(false);
    sessionStorage.setItem(STORAGE_KEY, '1');
  }

 // Show intro whenever the homepage loads
if (window.location.pathname === '/') {
  sessionStorage.removeItem(STORAGE_KEY);
  showIntro();
} else {
  hideIntro();
}

  // MENU toggle
  if (menuBtn) {
    menuBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (!menuPanel) return;
      openMenu(!menuPanel.classList.contains('is-open'));
    });
  }

  // Close menu when clicking outside
  intro.addEventListener('click', (e) => {
    if (!menuPanel || !menuPanel.classList.contains('is-open')) return;
    const clickedMenuBtn = menuBtn && (e.target === menuBtn || menuBtn.contains(e.target));
    const clickedInsidePanel = e.target === menuPanel || menuPanel.contains(e.target);
    if (!clickedMenuBtn && !clickedInsidePanel) openMenu(false);
  });

  // Any link inside intro
intro.querySelectorAll('a[href]').forEach(a => {
  a.addEventListener('click', () => {
    const href = a.getAttribute('href');
    if (!href || href === '#') return;

    if (a.id === 'IntroShopBtn') {
      sessionStorage.removeItem(STORAGE_KEY);
      return;
    }

    hideIntro();
  });
});

  // Logo click shows intro again (no navigation)
  const logo = document.querySelector('.header__heading-link');
  if (logo) {
    logo.addEventListener('click', (e) => {
      e.preventDefault();
      sessionStorage.removeItem(STORAGE_KEY);
      showIntro();
    });
  }
})();